import { render, staticRenderFns } from "./warnStatistics.vue?vue&type=template&id=5d0e32a9&"
import script from "./warnStatistics.vue?vue&type=script&lang=js&"
export * from "./warnStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports